import React, { ChangeEvent, useCallback } from 'react';
import { AppRadioButton, AppRadioButtonConfig } from './app-radio-button';
import './app-radio-button.scss';

export interface AppRadioGroupProps {
  selectedValue?: string;
  options: AppRadioButtonConfig[];
  onSelectedValueChanged: (value: string, field?: any) => void;
  horizontal?: boolean;
  label?: string;
  renderLabelFirst?: boolean;
  valid?: boolean;
  layered?: boolean;
  disabled?: boolean;
  readonly?: boolean;
}

export const AppRadioGroup = (props: AppRadioGroupProps) => {
  const { renderLabelFirst, selectedValue, options, onSelectedValueChanged, horizontal, label, valid = true, layered, disabled, readonly } = props;
  const validValues = new Set(options.map(o => o.value));
  const cleanedValue = [...new Set(selectedValue?.split(','))]
      .filter(v => validValues.has(v));
  const newSelectedValue = cleanedValue.join(',');
  const onSelect = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      e.currentTarget.closest('.mifid-question')?.classList.remove('error');
      onSelectedValueChanged(e.target.value);
    },
    [onSelectedValueChanged]
  );

  return (
    <div className={`app-radio-group ${horizontal ? 'horizontal-radio-button-group' : ''}`}>
      {label && <label className='app-radio-group-title'>{label}</label>}
      {options.map((option, index) => (
        <AppRadioButton
          valid={valid}
          key={index}
          renderLabelFirst={renderLabelFirst}
          checked={newSelectedValue === option.value}
          onSelect={onSelect}
          {...option}
          layered={layered}
          disabled={disabled || option.disabled}
          readonly={readonly}
        />
      ))}
    </div>
  );
};
